module.exports = __webpack_public_path__ + "673128e80ef40b59b4eecb9763909637.fbx";